<pay-icon [name]="icon" class="x-icon-btn__icon" [ngClass]="iconClasses" *ngIf="icon"></pay-icon>
<ng-content></ng-content>
